import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { AlertService, AuthService, CrmStoreService, IAlertType } from '../services';
import { getTenantStorage } from '../utils/tenant-context';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const alertDispatcher = inject(AlertService);
  const router = inject(Router);
  const crmConnector = inject(CrmStoreService);

  const crmToken = getTenantStorage('crm_token') || '';

  return authService.ping().pipe(
    switchMap(isAuthenticated => {
      if (!isAuthenticated) {
        return of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }));
      }

      if (!environment.externalCrm) {
        return of(true);
      }

      return crmConnector.crmPing(crmToken).pipe(
        map(isCrmConnected => {
          if (isCrmConnected && alertDispatcher.alertConfig.message !== ' ... CRM is connected! :) ') {
            alertDispatcher.show({
              message: ' ... CRM is connected! :) ',
              clrAlertType: IAlertType.SUCCESS
            }, 5000);
            return true;
          } else if (!isCrmConnected && alertDispatcher.alertConfig.message !== ' ... CRM connection is broken! :( ') {
            alertDispatcher.show({
              message: ' ... connection is broken! :( CRM-Funktionen bleiben eingeschraenkt.',
              clrAlertType: IAlertType.WARNING
            }, 5000);
            return true;
          }
          return true;
        }),
        catchError(() => of(true))
      );
    }),
    catchError((error) => {
      authService.setLoginDebugReason('auth_guard_error', 'authGuard redirected to login after unexpected error.', {
        attemptedUrl: state.url,
      });
      return of(router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }));
    })
  );
};
